<svg #graph style="position: relative; overflow: visible; width: 100%; height: 100%"></svg>
